"use strict";
// Cookie Consent is initialized in GTM.
// Before page cache, we need to remove the cookie consent banner from the DOM and reset the cookie consent library.
document.addEventListener('turbo:before-cache', () => {
    const cookieConsentBannerContainer = document.querySelector('#cookie-consent-banner-container');
    if (cookieConsentBannerContainer) {
        cookieConsentBannerContainer.innerHTML = '';
    }
    // @ts-ignore
    window.CookieConsent?.reset();
});
// After page load, we need to push the event to the data layer to get Cookie Consent initialized again.
document.addEventListener('turbo:load', () => window.dataLayer.push({ event: 'memberships_turbo_load' }));
